import { api } from "../../services/api";

export async function fetchUpdateDados(email, senhaAntiga, novaSenha) {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.post(
      "/perfil/updated",
      {
        email,
        currentPassword: senhaAntiga,
        newPassword: novaSenha
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}
